<template>
  <div class="col-md-12">
    <Form :validation-schema="schema" @submit="handleForm">
      <div>
        <Header></Header>
        <div class="header-group">
          <h1><img src="@/assets/img/underline.png"> MOT DE PASSE OUBLIÉ</h1>
        </div>

        <div class="form-group">
          <Field class="form-control" name="email" placeholder="Email" type="email"/>
          <ErrorMessage class="error-feedback" name="email"/>
        </div>

        <div class="form-group">
          <button :disabled="isDisabled" class="btn btn-primary btn-block">
            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
            Réinitialiser le mot de passe
          </button>
        </div>

        <div
            v-if="message"
            :class="successful ? 'alert-success' : 'alert-danger'"
            class="alert"
        >
          {{ message }}
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";

import Header from '@/views/public/newAccount/Header.vue'
import AuthApi from "@/api/AuthApi";

export default {
  name: "PasswordForgotten",
  components: {
    Form,
    Field,
    ErrorMessage,
    Header
  },
  data() {
    const schema = yup.object().shape({
      email: yup
          .string()
          .required("L'email est nécessaire")
          .email("L'email est invalide")
          .max(50, "Doit comporter au maximum 50 caractères"),
    })

    return {
      schema,
      message: "",
      successful: false,
      loading: false,
      message: null,
      successful: false
    };
  },
  computed: {
    isDisabled: function () {
      if (this.loading) return true;
      return false;
    },
  },
  methods: {
    handleForm(form) {
      this.loading = true
      AuthApi.requestNewPassword(form.email).then(
          (response) => {
            this.message = response.data.message
            this.successful = true
            this.loading = false
          },
          (error) => {
            this.message = error.response.data.detail
            this.successful = false
            this.loading = false
          }
      );
    }
  }
};
</script>
